import { getStaticAsset } from '@/utils/staticAsset';
import { Prize, PrizeType } from '../types';
import { WHEEL_ALL_PRIZE_LIST } from '@/components/features/casino/rush/constances';
import { floorToN } from '@/components/features/casino/crash/GameBox/utils';

/* ====================== *
 *    wheel game config
 * ====================== */
export const pcWheelSize = {
  width: 698,
  height: 698,
};

export const mobileWheelSize = {
  width: 550,
  height: 550,
};

export const wheelAnimationConfig = {
  speed: 20,
  accelerationTime: 1000,
  decelerationTime: 2500,
  offsetDegree: 360 / 18 / 2,
};
export const RUSH_DELAY =
  wheelAnimationConfig.accelerationTime +
  wheelAnimationConfig.decelerationTime +
  500;

export const blocks = [
  {
    imgs: [
      {
        src: getStaticAsset('/assets/images/casino/rush-game/wheel.png'),
        width: '100%',
        rotate: true,
      },
      {
        src: getStaticAsset('/assets/images/casino/rush-game/wheel-arrow.png'),
        width: '62.9%',
        rotate: false,
        top: '18%',
      },
    ],
  },
];
const getActiveLayer = (isMobile) => {
  const layerSrc = getStaticAsset(
    '/assets/images/casino/rush-game/prize-active.png',
  );
  if (isMobile) {
    return {
      src: layerSrc,
      top: 8,
      width: '101px',
      height: '98px',
    };
  } else {
    return {
      src: layerSrc,
      top: 9,
      width: '130px',
      height: '126px',
    };
  }
};

const getCommonImageProp = (isMobile) => {
  if (isMobile) {
    return {
      top: 22,
      width: '60px',
      height: '60px',
    };
  } else {
    return {
      top: 32,
      width: '70px',
      height: '70px',
    };
  }
};
const getActiveImageProp = (isMobile) => {
  if (isMobile) {
    return {
      top: -3,
      width: '80px',
      height: '80px',
    };
  } else {
    return {
      top: 0,
      width: '110px',
      height: '100px',
    };
  }
};
const getCommonFontProp = (isMobile) => {
  if (isMobile) {
    return {
      top: 80,
      fontSize: '10px',
    };
  } else {
    return {
      top: 100,
      fontSize: '12px',
    };
  }
};
const getCommonTopFontProp = (isMobile) => {
  if (isMobile) {
    return {
      top: 16,
      fontSize: '10px',
    };
  } else {
    return {
      top: 20,
      fontSize: '12px',
    };
  }
};
const getActiveFontProp = (isMobile) => {
  if (isMobile) {
    return {
      top: 70,
      fontSize: '12px',
    };
  } else {
    return {
      top: 90,
      fontSize: '14px',
    };
  }
};

const getElements = (prize: Prize, isMobile, rushBetAmount) => {
  const getMultiplier = (multiplier) => {
    return multiplier + 'x';
  };

  const commonImage = {
    ...getCommonImageProp(isMobile),
    src: prize.img,
  };
  const activeImage = {
    ...getActiveImageProp(isMobile),
    src: prize.openImg || prize.img,
  };
  const commonFonts = [
    // {
    //   ...getCommonTopFontProp(isMobile),
    //   fontColor: 'rgba(255,255,255,0.5)',
    //   text: prize.probability,
    // },
    {
      ...getCommonFontProp(isMobile),
      fontColor: '#fff',
      text: getMultiplier(prize.multiplier),
    },
  ];
  const activeFonts = [
    // {
    //   ...getCommonTopFontProp(isMobile),
    //   fontColor: 'rgba(255,255,255,1)',
    //   text: prize.probability,
    // },
    {
      ...getActiveFontProp(isMobile),
      fontColor: '#fff',
      text: getMultiplier(prize.multiplier),
    },
  ];

  return {
    commonImage,
    activeImage,
    commonFonts,
    activeFonts,
  };
};

export function getPrizes(resultIndex = -1, { isMobile, rushBetAmount }) {
  const activeLayer = getActiveLayer(isMobile);

  // active reward value
  return WHEEL_ALL_PRIZE_LIST.map((prize, index) => {
    const { commonImage, activeImage, commonFonts, activeFonts } = getElements(
      prize,
      isMobile,
      rushBetAmount,
    );
    if (index === resultIndex) {
      return {
        imgs: [activeLayer, activeImage],
        fonts: activeFonts,
      };
    } else {
      return {
        imgs: [commonImage],
        fonts: commonFonts,
        // background:index%2==0?'#f1f1f1':'#fff'
      };
    }
  });
}
